import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/market-cars.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { MarketCar } from "@/types/market";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for market cars
  const mock = AxiosMock.getInstance();
  const uri = new RegExp("^/carburate/market/cars/\\w+/$");
  mock.onGet(uri).reply(200, data.results[0]);
}

export const getMarketCar = (carId?: string) => {
  return api.get(`/carburate/market/cars/${carId}/`) as Promise<MarketCar>;
};

export const getMarketCarQueryOptions = ({ carId }: { carId?: string }) => {
  return queryOptions({
    queryKey: ["market", "cars", carId],
    queryFn: () => getMarketCar(carId),
    staleTime: 0,
  });
};

type UseMarketCarsOptions = {
  carId?: string;
  queryConfig?: QueryConfig<typeof getMarketCar>;
};

export const useMarketCar = ({ carId, queryConfig }: UseMarketCarsOptions) => {
  return useQuery({
    enabled: hasAccessToken() && !!carId,
    ...getMarketCarQueryOptions({ carId }),
    ...queryConfig,
  });
};
